import { useQuery } from 'react-query'
import { userHasGravatarQuery } from '../api/userQueries'

const EMPTY_QUERY = {
  enabled: false
}

/**
 * Determines if a user has a Gravatar.
 *
 * If `userImage` looks like from gravatar.com, checks  if this user really has image.
 *
 * Returns
 *   * `userImageIsFromGravatar`: true if `userImage` looks like from gravatar.com
 *   * `hasGravatar`: true if `userImage` is supposedly proper image
 */
export const useUserHasGravatar = ({ email, userImage }: { email?: string; userImage?: string }) => {
  const userImageIsFromGravatar = userImage?.includes('gravatar.com')
  const { data: hasGravatar } = useQuery(userImageIsFromGravatar && email ? userHasGravatarQuery(email) : EMPTY_QUERY)

  return {
    userImageIsFromGravatar,
    hasGravatar
  }
}
